import { pathOr } from 'ramda';
import { IAnswerSchema } from '../../../../node/repositories/lead-realtor-form/entities/question/AnswerSchema';
import { TFormStoreData } from '../../../types/form';
import { preloadImg } from '../../../utils/preloadImg';

export const preloadImagesFromResponse = (res: TFormStoreData) => {
  const preloaded = new Set();

  for (const questionKey of Object.keys(res.questions)) {
    const question = res.questions[questionKey as keyof typeof res.questions];

    const answers = pathOr([], ['answers'], question) as IAnswerSchema[];
    for (const answer of answers) {
      if (answer.imageUrl && !preloaded.has(answer.imageUrl)) {
        preloaded.add(answer.imageUrl);
        preloadImg(answer.imageUrl);
      }
    }
  }
};
